import PreviewNbioModal from './PreviewNbioModal.component';

export default PreviewNbioModal;
